<app-full-page-message *ngIf="localService.isServiceProviderBlocked()"></app-full-page-message>
<div class="{{localService.selectedLanguageCode}}"
  *ngIf="!localService.isServiceProviderBlocked() && localService.languageContent && localService.languageContent.appointments">
  <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
    [businesses]="localService.loggedMember.businesses"></app-business-deductive>
  <div style="max-width:1200px;" class="center">
    <div *ngIf="appointmentType == 2 && businessId == '0'" style="text-align:center;font-size:22px;">
      <span>{{localService.languageContent.appointments.new_service_provider}}</span>
      <br />
      <i class="material-icons button_icon" style="font-size:90px !important;"
        (click)="onOpenServiceProvider()">add_circle_outline</i>
    </div>
    <div *ngIf="appointmentType == 0 || businessId != '0'">
      <div class="banner">
        <div class="row">
          <div class="col-md-12">
            <label style="font-weight: normal; margin-left: 15px;">
              <input type="checkbox" [(ngModel)]="isShowExpired" (change)="onLoad()" />
              <span class="normal_color">{{localService.languageContent.appointments.include_expired}}</span>
            </label>
            <div style="float:right;" class="icon_adjust">
              <i class="material-icons on_language_changed" (click)="onLoad()">refresh</i>
              <i class="material-icons" *ngIf="appointmentType != 0" (click)="onOpenAppointment()"
                title="{{localService.languageContent.common.add}}">note_add</i>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!localService.isHideDummy">
          <div class="col-md-6">
            <div class="row">
              <div class="col-4 label_right">
                <app-label [Text]="localService.languageContent.appointments.customer"></app-label>
              </div>
              <div class="col-8">
                <app-business-relationship [businessId]="businessId" [isWithContactNumber]="appointmentType == 0"
                  (onUserUpdated)="onUserUpdated($event,1)"
                  [relationShipType]="relationShipType"></app-business-relationship>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-4 label_right">
                <app-label [Text]="localService.languageContent.appointments.service_provider"></app-label>
              </div>
              <div class="col-8">
                <app-business-relationship [businessId]="businessId" [isWithContactNumber]="appointmentType == 0"
                  (onUserUpdated)="onUserUpdated($event,2)"
                  [relationShipType]="relationShipType"></app-business-relationship>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner" style="margin-top:10px;" *ngIf="source && source.items.length > 0">
        <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
          <div class="row styled_row" *ngFor="let item of source.items">
            <div class="col-md-6">
              <div class="row">
                <div class="col-6">
                  <i class="material-icons icon_adjust" style="color:gray;">{{onGetIcon(item.v14)}}</i>
                  <span class="en button" (click)="onAction(item.v14,item.v13,item.v15)">{{item.v4}}</span>
                  &nbsp;
                  <i *ngIf="item.v3 == '0'" class="material-icons delete_icon icon_adjust"
                    (click)="onActionOnAppointment(item.key,4)"
                    title="{{localService.languageContent.common.cancel}}">cancel</i>
                </div>
                <div class="col-6">
                  <span [ngClass]="item.v11 == '-' ? 'button' : 'en button'"
                    (click)="onOpenAppointment(item.key)">{{item.v11}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-6 button">
                  <span [ngStyle]="{'color' : item.v1 == '1' ? 'green' : 'red'}"
                    [ngClass]="localService.getLanguageCode(item.v10)" (click)="onAction(0,item.v8)">
                    {{item.v9}}
                  </span>
                  <i class="material-icons icon_adjust" *ngIf="item.v1 == localService.selected.user"
                    style="color:green" title="{{localService.languageContent.common.cancel}}"
                    (click)="onActionOnAppointment(item.key,5)">check_circle</i>
                  <i class="material-icons icon_adjust" *ngIf="item.v1 != localService.selected.user"
                    (click)="localService.showMessage(item.v1 == '1' ? localService.languageContent.appointments.accepted_by_cust : localService.languageContent.appointments.not_accepted_by_cust)"
                    title="{{item.v1 == '1' ? localService.languageContent.appointments.accepted_by_cust : localService.languageContent.appointments.not_accepted_by_cust}}">info</i>
                </div>
                <div class="col-6 button">
                  <span [ngStyle]="{'color' : item.v2 == '1' ? 'green' : 'red'}"
                    [ngClass]="localService.getLanguageCode(item.v7)" (click)="onAction(0,item.v5)">
                    {{item.v6}}
                  </span>
                  <i class="material-icons icon_adjust" *ngIf="item.v2 == localService.selected.user"
                    style="color:green" title="{{localService.languageContent.common.cancel}}"
                    (click)="onActionOnAppointment(item.key,6)">check_circle</i>
                  <i class="material-icons icon_adjust" *ngIf="item.v2 != localService.selected.user"
                    (click)="localService.showMessage(item.v2 == '1' ? localService.languageContent.appointments.accepted_by_service_provider : localService.languageContent.appointments.not_accepted_by_service_provider)"
                    title="{{item.v1 == '1' ? localService.languageContent.appointments.accepted_by_service_provider : localService.languageContent.appointments.not_accepted_by_service_provider}}">info</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-paging *ngIf="source" [paging]="source.paging" [IsSimple]="true" [IsSimpleSearchBarReq]="false"
        (onPagingRefreshed)="onLoad()"></app-paging>
    </div>
  </div>
</div>